import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import VendasUniformesLayer from "../components/VendasUniformesLayer";
import { useTranslation } from "../i18n/I18nContext";

const VendasUniformesPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("venda.breadcrumb")} />
      <VendasUniformesLayer />
    </MasterLayout>
  );
};

export default VendasUniformesPage;
